module.exports = __webpack_public_path__ + "static/media/comunicado-desktop.72e61c23.png";